import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { LoginStatusSelector } from 'src/app/app-store/login/login.selector';
import { map } from 'rxjs/operators';
import { SetRequestUrl } from 'src/app/app-store/user/user.action';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard implements CanActivate {
  constructor(private store: Store, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.pipe(select(LoginStatusSelector)).pipe(
      map(result => {
        if (result) {
          return result;
        } else {
          this.store.dispatch(SetRequestUrl({ url: state.url }));
          this.router.navigateByUrl('/login');
          return false;
        }
      })
    );
  }
}
